import {
	getStudentName,
	getConnectedStudents,
	type JuniorMissionFullState,
	type JuniorQuestionAnswer as QuestionAnswer,
} from '@mission.io/mission-toolkit'
import { getScreen } from './video'
/**
 * Returns all connected students and those who responded to the question slot
 * question and the student's response
 */
export function getStudentsToShowForQuestionSlot(
	missionFullState: ?JuniorMissionFullState
): Array<{ id: string, fullName: string, response: ?QuestionAnswer }> {
	const screen = getScreen(missionFullState)
	if (!screen || screen.type !== 'QUESTION_SLOT') {
		return []
	}
	if (!missionFullState) {
		return []
	}
	const questionId = screen.questionId

	const questionResponses = ((missionFullState: any): JuniorMissionFullState)
		.questionData.answers
	const connectedStudents = getConnectedStudents(missionFullState)
	return Object.keys(connectedStudents).map(studentId => {
		const responses =
			questionResponses && questionResponses[studentId]
				? questionResponses[studentId][questionId]
				: null
		return {
			id: studentId,
			fullName: getStudentName(missionFullState, studentId) || 'Unknown name',
			response: responses ? responses[responses.length - 1] : null,
		}
	})
}
